import { BalancePaymentTranslations } from "./balancePaymentTranslations.types";

const balancePaymentNlTranslations: BalancePaymentTranslations = {
    balancePaymentPage: {
        title: "Saldo betaling",
        loading: "Betalingsinformatie laden...",
        processing: "Uw betaling wordt verwerkt...",
        processingDescription: "Even geduld terwijl we uw betaling bevestigen.",
        successTitle: "Betaling geslaagd!",
        successDescription: "Uw saldobetaling is succesvol verwerkt.",
        errorTitle: "Betaling kon niet worden voltooid",
        errorDescription: "Er is iets misgegaan bij het verwerken van uw betaling. Probeer het later opnieuw.",
        fullyPaidTitle: "Alle betalingen zijn up-to-date",
        fullyPaidDescription: "Er zijn geen openstaande saldoBetalingen voor deze boeking.",
        noBookingReference: "Geen boekingsreferentie opgegeven.",
        bookingReference: "Boekingsreferentie",
        departure: "Vertrek",
        returnDate: "Terugkeer",
        totalPrice: "Totale prijs",
        amountPaid: "Betaald bedrag",
        balanceDue: "Openstaand saldo",
        amountToPay: "Te betalen bedrag: {amount}",
        paymentModeTitle: "Kies je betaaloptie",
        payNextPayment: "Betaal volgende termijn",
        payFullBalance: "Betaal het volledige saldo",
    },
};

export default balancePaymentNlTranslations;
